import React from 'react';
import { Helmet } from 'react-helmet-async';

const Terms = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Service - AI Blog</title>
        <meta name="description" content="Our terms of service outline the rules and regulations for using our platform." />
      </Helmet>

      <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8">
            <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-8">
              Terms of Service
            </h1>
            
            <div className="prose prose-lg max-w-none dark:prose-invert">
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                <strong>Last updated:</strong> {new Date().toLocaleDateString()}
              </p>

              <h2>1. Acceptance of Terms</h2>
              <p>
                By accessing and using AI Blog, you accept and agree to be bound by the terms 
                and provision of this agreement.
              </p>

              <h2>2. Use License</h2>
              <p>
                Permission is granted to temporarily download one copy of AI Blog for personal, 
                non-commercial transitory viewing only. This is the grant of a license, not a 
                transfer of title, and under this license you may not:
              </p>
              <ul>
                <li>Modify or copy the materials</li>
                <li>Use the materials for any commercial purpose or for any public display</li>
                <li>Attempt to reverse engineer any software contained on the website</li>
                <li>Remove any copyright or other proprietary notations from the materials</li>
              </ul>

              <h2>3. User Accounts</h2>
              <p>
                When you create an account with us, you must provide information that is accurate, 
                complete, and current at all times. You are responsible for safeguarding the password 
                and for all activities that occur under your account.
              </p>

              <h2>4. Content</h2>
              <p>
                Our service allows you to post, link, store, share and otherwise make available 
                certain information, text, graphics, videos, or other material. You are responsible 
                for the content that you post to the service.
              </p>

              <h2>5. Prohibited Uses</h2>
              <p>You may not use our service:</p>
              <ul>
                <li>For any unlawful purpose or to solicit others to perform unlawful acts</li>
                <li>To violate any international, federal, provincial, or state regulations, rules, laws, or local ordinances</li>
                <li>To infringe upon or violate our intellectual property rights or the intellectual property rights of others</li>
                <li>To harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate</li>
                <li>To submit false or misleading information</li>
              </ul>

              <h2>6. Content Standards</h2>
              <p>
                Content must not be illegal, threatening, defamatory, obscene, or otherwise objectionable. 
                We reserve the right to remove any content that violates these standards.
              </p>

              <h2>7. Privacy Policy</h2>
              <p>
                Your privacy is important to us. Please review our Privacy Policy, which also governs 
                your use of the service.
              </p>

              <h2>8. Termination</h2>
              <p>
                We may terminate or suspend your account immediately, without prior notice or liability, 
                for any reason whatsoever, including without limitation if you breach the Terms.
              </p>

              <h2>9. Disclaimer</h2>
              <p>
                The information on this website is provided on an "as is" basis. To the fullest extent 
                permitted by law, we exclude all representations, warranties, conditions and terms 
                relating to our website and the use of this website.
              </p>

              <h2>10. Governing Law</h2>
              <p>
                These Terms shall be interpreted and governed by the laws of the United States, 
                without regard to its conflict of law provisions.
              </p>

              <h2>11. Contact Information</h2>
              <p>
                If you have any questions about these Terms of Service, please contact us at 
                legal@aiblog.com.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Terms;
